module.exports = __webpack_public_path__ + "src/client/assets/bank-logos/suntrust.png";


//////////////////
// WEBPACK FOOTER
// ./src/client/assets/bank-logos/suntrust.png
// module id = 1182
// module chunks = 0